/**
 * Defense-in-depth presentation guard. The authoritative enforcement is Shopify's
 * subscription-only product setting plus its selling-plan allocation at checkout.
 */
const DEVICE_HANDLES = new Set(['signal-pro', 'far-x', 'rover']);

function guardProductForms() {
  if (!DEVICE_HANDLES.has(document.body.dataset.productHandle)) return;
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const escapedId = window.CSS?.escape && form.id ? CSS.escape(form.id) : '';
      const plan =
        form.querySelector('[name="selling_plan"]') ||
        (escapedId ? document.querySelector(`[name="selling_plan"][form="${escapedId}"]`) : null);
      if (plan?.value) return;
      event.preventDefault();
      const message = form.querySelector('[data-trifi-plan-error]');
      if (message) {
        message.hidden = false;
        message.focus();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', guardProductForms, { once: true });
} else {
  guardProductForms();
}
